'use client'

import Image from 'next/image'
import { motion } from 'framer-motion'
import { Container } from '@/components/ui/container'
import { Section } from '@/components/ui/section'

export function MarketplaceMockupSection() {
  return (
    <Section background="white">
      <Container>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Marketplace app screenshot */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-sky-200/50 w-full h-[400px] sm:h-[500px] lg:h-[600px]">
              <Image
                src="/images/sections/marketplace-hero-img.png"
                alt="Buddify Marketplace - Browse quality products from independent brands"
                fill
                className="object-contain"
                sizes="(max-width: 1024px) 100vw, 50vw"
                priority
              />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <p className="text-micro-uppercase text-brand-blue mb-3">BUDDY MARKETPLACE APP</p>
            <h2 className="text-display-1 text-ink mb-4">
              A New Storefront in Every Customer&apos;s Pocket
            </h2>
            <p className="text-body-lg text-muted mb-6">
              The Buddify Marketplace iOS app puts your products in front of deal-hunting shoppers who actively search for independent brands.
            </p>

            <ul className="space-y-4 mb-8">
              {[
                'Native iOS shopping experience',
                'AI-negotiated discounts drive urgency',
                'Seamless Shopify order sync',
                'No extra listing fees',
              ].map((item) => (
                <li key={item} className="flex items-center gap-3 text-muted">
                  <span className="w-6 h-6 rounded-full bg-brand-blue-soft text-brand-blue flex items-center justify-center">
                    <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <a
              href="https://apps.apple.com/app/id6478976454"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-ink text-page font-semibold text-sm hover:opacity-90 transition-colors"
            >
              Download on the App Store
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
            </a>
          </motion.div>
        </div>
      </Container>
    </Section>
  )
}
